/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect } from "react";
// import { message } from "antd";
import { useRecoilValue } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import authAtom from "../atoms/auth.atom";
import appAtom from "../atoms/app.atom";
import PublicLayout from "./public";
import AuthLayout from "./auth";
import MainLayout from "./main";
import SecurityLayout from "./security";
import { message } from "antd";

const Layouts = {
  security: SecurityLayout,
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
};

type Props = {
  children: ReactElement<any>;
};

const Layout = ({ children }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const width = window.innerWidth;
  const { theme } = useRecoilValue(appAtom)
  const { isLoggedIn } = useRecoilValue(authAtom);

  // Layout Rendering
  const getLayout = () => {
    if (pathname === "/" || /^\/page(?=\/|$)/i.test(pathname)) return "public";
    if (/^\/security(?=\/|$)/i.test(pathname)) return "security";
    if (/^\/auth(?=\/|$)/i.test(pathname)) return "auth";
    return "main";
  };

  const Container: any = Layouts[getLayout()];

  const isMobile = (width <= 500);
  const isMainLayout = getLayout() === "main";
  const isPublicLayout = getLayout() === "public";
  const isSecurityLayout = getLayout() === "security";

  // scroll to top when path changes
  useEffect(() => {window.scrollTo(0, 0)}, [pathname]);

  // navigate to main screen if app is on mobile view and layout is public
  useEffect(() => {if (isMobile && isPublicLayout) navigate("/dashboard") }, [isMobile, isPublicLayout]);

  // redirect to login page if current is not login page and user not authorized
  useEffect(() => { if ((isMainLayout || isSecurityLayout) && !isLoggedIn) {
    message.info({ content: "please authenticate to proceed.", key: "updatable" });
    sessionStorage.setItem("fallback", JSON.stringify(location));
    navigate("/auth/login");
  }}, [isLoggedIn, isMainLayout, location, navigate]);

  return (
    <div className={'w-full h-screen '.concat(theme!)}>
      <Container>{children}</Container>
    </div>
  )
}

export default Layout